import { useThemeStore } from "@/theme/themeStore";

export const useTheme = () => {
  return useThemeStore();
};
